/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Intent, Tag } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { ID } from "src/libs/interfaces/layouts"
import { LoaderMinimal } from "src/libs/useful/Loading"
import { __, __cases, wordTrim } from "src/libs/utilities"
import actions from "src/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { IProject, ITrack } from "src/modules/pe-fest-module/data/interfaces"
import { IFestMyProjectsProps, useFestMyProjects } from "src/modules/pe-fest-module/data/store"
import { IState, useMainStore } from "src/settings/zustand"

/* Protopia Ecosystem component */
export interface IHoneycombsPartnersProps {
   project?: IProject
   track?: ITrack 
}
const TrackPartners = (props: IHoneycombsPartnersProps): JSX.Element => {
    const _landId : ID = useMainStore((state:IState) => state.landId )
    const myProjects: IProject[] = useFestMyProjects((state: IFestMyProjectsProps) => state.myProjects)
    const [projects, setProjects] = useState<IProject[]>([])
    const [isOpen, setIsOpen] = useState<boolean>( false )
    const [isLoad, setIsLoad] = useState<boolean>( false )
    useEffect(() => {
        if(props.track?.id) {
            setIsLoad(true)
            actions(
                GET_FEED_ACTION,
                {
                    land_id : _landId, 
                    data_type: "PEFestProject",
                    seed: "project-track",
                    paging: `taxonomies:[ {tax_name: "fmru_track", term_ids: [ ${props.track.id} ] }],  order_by_meta: "title" , order: "ASC", search:"" `
                }).then((response: any) => {    
                    setIsLoad(false)               
                    setProjects( response.feed ) 
                })
        }
    }, [ ])

    const isMine = (id: ID): boolean => {
        return myProjects.map(p => p.id).includes(id)
    } 
    
    return <div className='d-flex flex-wrap'>
       {
            !isOpen
            ?
            <Button variant={ButtonVariant.MINIMAL} endIcon="caret-down" onClick={()=> setIsOpen(!isOpen)} >
                <div className="small letter-spacing-1">
                    { 
                        !!projects.length 
                            ? 
                            `${projects.length} ${__cases(projects.length, "projects")}`  
                            : 
                            isLoad
                                ?
                                <LoaderMinimal />
                                :
                                __("Projects not exist")
                    }
                </div>
            </Button>
            :
            props.track?.id && projects.length > 0
                ?
                projects.map(project => {
                    return project.id !== (props.project?.id || "")
                        ?
                        <Link key={project.id} to={`/fest/${ _landId }/project/${project.id}/`}>
                            <Tag className="mr-1 mb-1 " intent={isMine(project.id) ? Intent.DANGER : Intent.NONE}> 
                                { wordTrim( project.title, 5 ) }
                            </Tag>
                        </Link>
                        : 
                        <Tag className="mr-1 mb-1 opacity_5"  intent={isMine(project.id) ? Intent.DANGER : Intent.NONE} key={project.id}> 
                            { wordTrim( project.title, 5 )  }
                        </Tag>
                })
                :
                <></>
       }
    </div>
}
export default TrackPartners